import { of } from 'rxjs';
import { booleanOptions, eqOperator, fullComparator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getPassifsBuilders(): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'PASSIFS',
      'PATRIMOINE_PASSIFS_PROCHAINE_ECHEANCE',
      'bilanFinancier.dateProchaineEcheance',
      fullComparator,
      'DateTime',
      undefined
    ),
    new ItemFiltreCustomBuilder(
      'PASSIFS',
      'PATRIMOINE_PASSIFS_EN_COURS',
      'bilanFinancier.aCreditEnCours',
      eqOperator,
      'Select',
      of(booleanOptions)
    ),
    new ItemFiltreCustomBuilder(
      'PASSIFS',
      'PATRIMOINE_PASSIFS_CAPITAL_RESTANT_DU',
      'bilanFinancier.effectivePassif',
      fullComparator,
      'InputEuro',
      undefined
    ),
  ];
}
